import React, { useEffect } from 'react'
import { studentInProductHelpLinks } from '../../../../constants/helpLinks'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'
import { GetBrandedAppName } from '../../../../services/BrandingService'
import StudentInstruction from '../../Components/StudentInstruction'
import TestButton from '../../Components/TestButton'
import { PRE_CHECK_MACHINE_STATES } from '../../constants'
import { getCopyByGradeband } from '../../../../services/ThemingService'

export default function NetworkPingProblemInstruction({ retry, speechProps, forceThroughNetworkCheck, toggleReaderContainer }) {

  useEffect(() => {
    toggleReaderContainer()
    networkErrorSpeech()

    return () => {
      toggleReaderContainer()
    }

  }, [])

  const networkErrorSpeech = async () => {
    const studentChecks = getCopyByGradeband(COPY_STRINGS, 'student_checks');
    speechProps.speakWithPromise({ textToSpeak: studentChecks.network_ping_error })
    speechProps.speakWithPromise({ textToSpeak: studentChecks.handle_get_teacher_two })
  }

  return (
    <div>
      <StudentInstruction>
        <h2>Raise your hand</h2>
        <p>We aren't able to reach one of the services that {GetBrandedAppName()} requires to work properly. Please contact your IT department to ensure that {GetBrandedAppName()} has access to the services listed at this link. For additional assistance, contact <a href="mailto:support@amiralearning.com">support@amiralearning.com</a>. Error code: 1234</p>
        <TestButton action="Retry" currentCheck={PRE_CHECK_MACHINE_STATES.networkPingChecks} retry={retry} />
        <p>Your internet connection is unstable. See this <a target="_blank" href={studentInProductHelpLinks.networkPingGeneral}>network help link</a> for details and troubleshooting steps. If you'd like to proceed anyway, tap “Continue”.</p>
        <button className="teacher-troubleshoot-button" onClick={forceThroughNetworkCheck}>Continue</button>
      </StudentInstruction>
    </div>
  )
}
